export enum RuleTargetAction {
  HIDE = 'Hide',
  DISABLE = 'Disable',
  REQUIRE = 'Require',
  OPTIONAL = 'Optional'
}
